module.exports = __webpack_public_path__ + "assets/HKNova-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Bold.ttf
// module id = 145
// module chunks = 0